import { Component } from '@angular/core';

@Component({
  selector: 'rs-sad-message',
  templateUrl: 'sad-message.component.html'
})
export class SadMessageComponent {}
